import i18n from 'src/i18n';
import moment from 'moment';
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'date_save',
      label: i18n.t('common_words.header'),
      minWidth: 110,
      align: 'center',
      sortable: true,
    },
    {
      prop: 'module',
      label: i18n.t('common_words.module'),
      minWidth: 100,
      align: 'left',
      sortable: true,
    },
    {
      prop: 'farm_name',
      label: i18n.t('common_words.farm'),
      minWidth: 100,
      align: 'left',
    },
    {
      prop: 'store_user_name',
      label: i18n.t('common_words.creatorUser'),
      minWidth: 150,
      align: 'left',
    },
    {
      prop: 'createdAt',
      label: i18n.t('common_words.creationDate'),
      minWidth: 100,
      align: 'center',
      sortable: true,
    },
    {
      prop: 'updated_user_name',
      label: i18n.t('common_words.updaterUser'),
      minWidth: 150,
      align: 'left',
    },
    {
      prop: 'updated_date',
      label: i18n.t('common_words.updateDate'),
      minWidth: 100,
      align: 'center',
      sortable: true,
    },
  ];

  const Search = { ...Tables.Search };

  return { Table, Search };
};
export default configTable;
